var render = function () {
  var _vm$rewardCard$title, _vm$rewardCard;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RewardCardList",
      "extra-items": [{
        text: (_vm$rewardCard$title = (_vm$rewardCard = _vm.rewardCard) === null || _vm$rewardCard === void 0 ? void 0 : _vm$rewardCard.title) !== null && _vm$rewardCard$title !== void 0 ? _vm$rewardCard$title : '',
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, '集點獎項']
    }
  })], 1)]), _c('b-card', [_c('h4', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_vm.checkPermission([_vm.consts.REWARD_GIFT_CREATE]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: _vm.selectModal,
      expression: "selectModal"
    }],
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.showLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.selectItemTitle))]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_GIFT_MODIFY]) ? _c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "success",
      "disabled": _vm.showLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1), _c('RewardGiftListProductSelection', {
    attrs: {
      "merchant-id": _vm.merchantId,
      "selected-products": _vm.selectedProducts
    },
    on: {
      "selected": function selected($event) {
        return _vm.handleUpdateSelectedItems('Product', $event);
      }
    }
  }), _c('SearchCoupon', {
    attrs: {
      "mode": "multiple",
      "selectedCoupons": _vm.selectedCoupons
    },
    on: {
      "submit": function submit($event) {
        return _vm.handleUpdateSelectedItems('RedeemCodeBundle', $event);
      }
    }
  }), _c('b-card-text', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.rewardGifts,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": true,
            "unchecked-value": false,
            "disabled": _vm.isReadOnly
          },
          model: {
            value: data.item.is_enabled,
            callback: function callback($$v) {
              _vm.$set(data.item, "is_enabled", $$v);
            },
            expression: "data.item.is_enabled"
          }
        })];
      }
    }, {
      key: "cell(order)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "text",
            "readonly": _vm.isReadOnly
          },
          model: {
            value: data.item.order,
            callback: function callback($$v) {
              _vm.$set(data.item, "order", $$v);
            },
            expression: "data.item.order"
          }
        })];
      }
    }, {
      key: "cell(product_title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProductDetail',
              params: {
                product_id: data.item.target_id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data, 'item.target.title')))]), _c('div', [_vm._v(_vm._s(_vm.deepGet(data, 'item.target.sale_page_code')))])])];
      }
    }, {
      key: "cell(coupon_title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RedeemCodeBundleDetail',
              params: {
                redeemCodeBundleId: data.item.target_id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data, 'item.target.name')))])])];
      }
    }, {
      key: "cell(image)",
      fn: function fn(data) {
        return [_vm.deepGet(data, 'item.target.images[0].pic_url') ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": _vm.deepGet(data, 'item.target.images[0].pic_url'),
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(point_need)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "text",
            "readonly": _vm.isReadOnly
          },
          model: {
            value: data.item.point_need,
            callback: function callback($$v) {
              _vm.$set(data.item, "point_need", $$v);
            },
            expression: "data.item.point_need"
          }
        })];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.REWARD_GIFT_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteRewardGift(data);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }